
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Events",
      function () {
        return require("private-next-pages/Events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Events"])
      });
    }
  